import { http } from "./http";
import { GET_ORDER_DETAILS_IN_PROVIDERNOTIFICATION, SAVE_PROVIDER_SIGN_FOR_ORDER } from "./URL";

export const getOrderDetailsByOrderIdForProvider = async (orderId:any) => {
  try {
    const response = await http.get(`${GET_ORDER_DETAILS_IN_PROVIDERNOTIFICATION}?orderId=${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveProviderSignatureForOrder = async (data:any) => {
  try {
    const response = await http.post(SAVE_PROVIDER_SIGN_FOR_ORDER, data);
    return response;
  } catch (error) {
    throw error;
  }
}